import {
  takeLatest,
  put,
  call,
  delay,
  select,
  takeEvery,
} from "redux-saga/effects";
import {
  MF_DETAIL_PENDING,
  MF_DETAIL_SUCCESS,
  MF_DETAIL_FAILURE,
  MF_CATEGORY_PENDING,
  MF_CATEGORY_SUCCESS,
  MF_CATEGORY_FAILURE,
  MF_CATEGORY_DROP_PENDING,
  MF_CATEGORY_DROP_SUCCESS,
  STP_SCHEME_FAILURE,
  STP_SCHEME_SUCCESS,
  STP_SCHEME_PENDING,
} from "../redux/types/preloginType";
import { MFCatSuccuess } from "../redux/actions/preloginAction";
import Api from "../services/preLoginApi";

let allApi = new Api();

async function getFetch(data) {
  let ResData = await allApi.fundDetail(data);
  return ResData;
}

function* fetchData(action) {
  let payload = action.payload;
  let apiresponse = yield call(getFetch, payload);
  if (apiresponse?.data?.success) {
    yield put({ type: MF_DETAIL_SUCCESS, payload: apiresponse?.data?.data });
  } else {
    yield put({ type: MF_DETAIL_FAILURE, payload: null });
  }
  // yield put({ type: ABOUTUS_DATA_SUCCESS, payload: apiresponse?.data })
}

export function* MFDetail() {
  yield takeLatest(MF_DETAIL_PENDING, fetchData);
}

// category page

function CreateDataSet(dropFilter, staticData) {
  let allKey = Object.keys(dropFilter);
  let modifyArray = [];
  let dropOpt = [];

  allKey.forEach((element) => {
    let arrayData = [];        
    staticData[element].map((curr) => {      
      arrayData.push(curr.fundoptionmerge);
      dropOpt.push(curr);
      if (curr.fundoptionmerge === dropFilter[element]) {
        modifyArray.push({ ...curr, selectBox: arrayData });
      }
    });
  });

  return { modifyArray: modifyArray, dropOpt: dropOpt };
}

function* CategoryData(cateType) {
  let payload = {
    api_name: "FundCategory",
    categoryType: cateType.paylaod,
  };
  let apiresponse = yield allApi.Category(payload);

  if (apiresponse?.data?.success) {
    let dataset = apiresponse?.data?.data;
    let enObj = {};
    for (let [key, value] of Object.entries(dataset)) {
      value.map((curr, index) => {
        if (curr.schcode === key) {
          enObj[key] = curr.fundoptionmerge;
        }
      });

      // SetDropFilter(enObj)
    }
    yield delay(100);
    let createdDataSet = CreateDataSet(enObj, dataset);
    //yield put(MFCatSuccuess(dataset))
    yield put({
      type: MF_CATEGORY_SUCCESS,
      payload: {
        dropdown: enObj,
        modifyCat: createdDataSet.modifyArray,
        CatData: dataset,
        dropOpt: createdDataSet.dropOpt,
      },
    });
  } else {
    yield put({
      type: MF_CATEGORY_FAILURE,
      payload: { dropdown: {}, modifyCat: [], CatData: null },
    });
  }
}

export function* Category() {
  yield takeLatest(MF_CATEGORY_PENDING, CategoryData);
}

export function* STPCategoryData(action) {
  // let payload = {
  //   api_name: "SchemesForSTP",
  // };
  let payload = action.paylaod;
  let apiresponse = yield allApi.STPCategory(payload);
  if (apiresponse?.data?.success) {
    let dataset = apiresponse?.data?.data;

    yield put({ type: STP_SCHEME_SUCCESS, payload: dataset });
  } else {
    yield put({ type: STP_SCHEME_FAILURE, payload: null });
  }
}

export function* STPCategory() {
  yield takeLatest(STP_SCHEME_PENDING, STPCategoryData);
}

// dropDown Selection
export const getProject = (state) => state.MfDetail.category;
function* FilterDrop(action) {
  let CatData = yield select();
  let stateCate = CatData.MfDetail.category;
  let getActionDrop = action.paylaod;
  let mData = yield CreateDataSet(getActionDrop, stateCate);
  yield put({
    type: MF_CATEGORY_SUCCESS,
    payload: {
      dropdown: getActionDrop,
      modifyCat: mData.modifyArray,
      CatData: stateCate,
    },
  });
}

export function* DropFilter() {
  yield takeEvery(MF_CATEGORY_DROP_PENDING, FilterDrop);
}
